import { AxiosRequestConfig } from "axios";

export const getPaymentMethods = (): AxiosRequestConfig => {
  return {
    url: `/v3/payment-methods`,
    method: "GET",
  };
};

export const getVirtualCard = (): AxiosRequestConfig => {
  return {
    url: `/v3/payment-methods/vc`,
    method: "GET",
  };
};

export const getAchBankAccount = (): AxiosRequestConfig => {
  return {
    url: `/v3/payment-methods/ach-bank-account`,
    method: "GET",
  };
};

export const getAchBankAccountSchema = (): AxiosRequestConfig => {
  return {
    url: `/v3/payment-methods/ach-bank-account-schema`,
    method: "GET",
  };
};

export const makeTransferToBankAccount = (data: any): AxiosRequestConfig => {
  return {
    url: `/v3/payment-methods/make-ach-out`,
    method: "POST",
    data: data,
  };
};

export const acceptCardAgreement = (): AxiosRequestConfig => {
  return {
    url: "/v3/payment-methods/terms-and-conditions-highnote-vc/accept",
    method: "PUT",
  };
};
